import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

const reducers = combineReducers({
    dadosClienteReducer: require('../ducks/dados-cliente').dadosClienteReducer,
    dadosCotacaoReducer: require('../ducks/dados-cotacao').dadosCotacaoReducer,
    stepReducer: require('../ducks/step').stepReducer,
    listaBensReducer: require('../ducks/lista-bens').listaBensReducer,
    tipoSimulacaoReducer: require('../ducks/tipo-simulacao').tipoSimulacaoReducer,
    combosReducer: require('../ducks/combos').combosReducer,
    enderecosReducer: require('../ducks/enderecos').enderecosReducer,
    beneficiariosReducer: require('../ducks/beneficiarios').beneficiariosReducer,
    dadosComplementaresReducer: require('../ducks/dados-complementares').dadosComplementaresReducer,
    leafletReducer: require('../ducks/leaflet').leafletReducer,
    historicoAcessoReducer: require('../ducks/historico-acesso').historicoAcessoReducer,
    form: formReducer
});

export default reducers;
